import { render, staticRenderFns } from "./ResetPasswordRequest.vue?vue&type=template&id=5dd04b0c&scoped=true"
import script from "./ResetPasswordRequest.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordRequest.vue?vue&type=script&lang=ts"
import style0 from "./ResetPasswordRequest.vue?vue&type=style&index=0&id=5dd04b0c&prod&lang=scss&scoped=true"
import style1 from "./ResetPasswordRequest.vue?vue&type=style&index=1&id=5dd04b0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd04b0c",
  null
  
)

export default component.exports